// removed by extract-text-webpack-plugin
module.exports = {"form":"c-AddressForm__form","checkbox":"c-AddressForm__checkbox","fields":"c-AddressForm__fields","addressReadOnly":"c-AddressForm__addressReadOnly"};